export function entityTypeFields(entityType) {
    const fields = [];
    const ids = new Set();
    const addField = field => {
        if (!field || ids.has(field.id)) return;
        ids.add(field.id);
        fields.push(field);
    };

    entityType?.custom_meta_groups?.forEach(groupMembership => {
        groupMembership.custom_meta_group?.custom_meta_fields?.forEach(fieldMembership => {
            addField(fieldMembership.custom_meta_field);
        });
    });

    entityType?.custom_meta_fields?.forEach(fieldMembership => {
        addField(fieldMembership.custom_meta_field);
    });

    return fields;
}

export function normalizeEntityAssetFormValues(values, entityType) {
    const fieldsById = new Map(entityTypeFields(entityType).map(field => [field.id.toString(), field]));
    const customMeta = Object.entries(values.custom_meta || {}).reduce((attrs, [fieldId, value]) => {
        attrs[fieldId] = normalizeCustomMetaValue(value, fieldsById.get(fieldId));
        return attrs;
    }, {});

    return {
        ...values,
        custom_meta: customMeta
    };
}

export function entityAssetFormHasRequiredValues(values, entityType) {
    if (!hasFormValue(values?.filename)) return false;

    return entityTypeFields(entityType)
        .filter(field => field.required)
        .every(field => hasFormValue(values?.custom_meta?.[field.id.toString()]));
}

function normalizeCustomMetaValue(value, field) {
    if (Array.isArray(value)) return value.map(item => normalizeCustomMetaValue(item, field)).filter(item => item !== null && item !== undefined && item !== "");
    if (value === null || value === undefined || value === "") return value;

    if (value?.format) {
        if (field?.value_type === "date") return value.format("YYYY-MM-DD");
        if (field?.value_type === "datetime") return value.toISOString ? value.toISOString() : value.format();
    }

    return value;
}

function hasFormValue(value) {
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "string") return value.trim().length > 0;

    return value !== null && value !== undefined && value !== "";
}
